var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeMailCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 135,
    viewBox: "0 0 134 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1089 19.704C41.1123 19.7151 38.8559 20.6781 36.919 21.929C34.967 23.1897 33.1752 24.8489 32.1353 26.4444C26.5774 34.9719 23.9811 41.4048 23.682 46.4711C23.3766 51.6451 25.4712 55.2875 28.9292 58.1293C32.3167 60.9132 37.0539 62.9636 42.1036 65.0556C42.53 65.2323 42.9591 65.4094 43.3904 65.5874C48.1192 67.5393 53.118 69.6025 57.8061 72.3944C62.493 75.1855 66.7347 79.0244 70.8619 82.7817L71.0695 82.9707C75.0844 86.6261 79.0263 90.2151 83.0696 92.4407C87.2341 94.733 91.6148 95.6392 96.3783 93.6919C101.065 91.7763 105.956 87.1616 111.367 78.8588C112.367 77.3254 113.367 75.1838 113.947 72.9962C114.517 70.8428 114.73 68.4558 113.923 66.5494L96.9209 26.4008C95.1314 22.1748 90.9951 19.4386 86.4347 19.4639L43.1089 19.704Z",
    fill: "url(#paint0_linear_2512_8578)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 75.0861H42C40.3431 75.0861 39 73.743 39 72.0861V39.7876C39 38.1307 40.3431 36.7876 42 36.7876H125C126.657 36.7876 128 38.1307 128 39.7876V72.0861C128 73.743 126.657 75.0861 125 75.0861Z",
    fill: "#DFE2EB",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45.8622C71.7184 45.8622 57 45.8622 57 45.8622",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66.0115C76.0112 66.0115 57 66.0115 57 66.0115",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55.9369C67.6667 55.9369 57 55.9369 57 55.9369",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 44.4C113.567 44.4 112 45.6536 112 47.2C112 48.7464 113.167 50 115.5 50C117.833 50 119 51.2536 119 52.8C119 54.3464 117.433 55.6 115.5 55.6M115.5 44.4C116.795 44.4 117.927 44.9631 118.532 45.8M115.5 44.4V43M115.5 55.6L115.5 57M115.5 55.6C114.205 55.6 113.073 55.0369 112.468 54.2",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 64.7381C118.153 64.8586 116.855 64.7542 115.737 63.7949C115.624 63.6983 115.445 63.7405 115.396 63.8806C115.168 64.5334 114.814 65.4712 114.54 65.9792C114.464 66.1195 114.291 66.079 114.26 65.9226L113.654 62.9051C113.619 62.7279 113.38 62.6872 113.278 62.836C109.236 68.7001 103.578 65.0347 102 59.869C100.833 56.0496 104.944 54.0049 107.5 56.8691C110.654 60.4038 110.389 65.225 104.944 67.9371C101.813 69.4969 98.9306 66.843 99.0571 63.4969C99.0643 63.305 98.8154 63.1793 98.6691 63.3037C98.0158 63.8589 96.976 64.5945 96 64.8376",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39.7876C39 38.1307 40.3431 36.7876 42 36.7876H125C126.657 36.7876 128 38.1307 128 39.7876V72.0861C128 73.743 126.657 75.0861 125 75.0861H42C40.3431 75.0861 39 73.743 39 72.0861V39.7876Z",
    fill: "url(#paint1_linear_2512_8578)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39.7876C39 38.1307 40.3431 36.7876 42 36.7876H125C126.657 36.7876 128 38.1307 128 39.7876V72.0861C128 73.743 126.657 75.0861 125 75.0861H42C40.3431 75.0861 39 73.743 39 72.0861V39.7876Z",
    fill: "url(#paint2_linear_2512_8578)",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39.7876C39 38.1307 40.3431 36.7876 42 36.7876H125C126.657 36.7876 128 38.1307 128 39.7876V72.0861C128 73.743 126.657 75.0861 125 75.0861H42C40.3431 75.0861 39 73.743 39 72.0861V39.7876Z",
    stroke: "white",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1111 24.4418C34.9668 24.1023 34.6491 23.8694 34.2839 23.8354C33.9187 23.8014 33.5651 23.9719 33.363 24.2791L3.04647 70.3809C2.1343 71.768 2.51715 73.64 3.90068 74.5576L78.2334 123.862C79.6175 124.78 81.4765 124.394 82.3803 123L112.442 76.6461C112.642 76.3378 112.658 75.9437 112.483 75.6194C112.308 75.2952 111.97 75.0931 111.604 75.0931L60.602 75.0931C58.203 75.0931 56.0322 73.6507 55.0876 71.4291L54.3296 69.6461L54.0942 69.0923L35.1111 24.4418Z",
    fill: "url(#paint3_linear_2512_8578)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51 61.9816L3 72.0562",
    stroke: "white",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70 75.0786L80 123.437",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2512_8578",
    x1: 115.884,
    y1: -15.0607,
    x2: 40.1439,
    y2: 99.4315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2512_8578",
    x1: 96.8528,
    y1: 78.1516,
    x2: 96.6735,
    y2: 63.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CBDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2512_8578",
    x1: 52.1491,
    y1: 61.1068,
    x2: 62.0886,
    y2: 54.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916786,
    stopColor: "#C4CBDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2512_8578",
    x1: 87.6964,
    y1: 27.6699,
    x2: 41.1029,
    y2: 98.1029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeMailCheck);
export default __webpack_public_path__ + "static/media/ic-large-mail-check.ae1ad2375488526378f90f9d9121d897.svg";
export { ForwardRef as ReactComponent };